import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import {
  IClienteAtualizarForm,
  IClienteDTO,
  IClienteForm,
  IClienteGetProps,
  IConcessionariaProps,
  IPageClienteDTO,
} from "../../types/cliente";

import { IPageRequest } from "../../types/page";
import objectToParams from "../../utils/objectToParams";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/cliente";

interface IClienteList extends IPageRequest {
  nomeCpfCnpj: string;
}

export class Cliente {
  static async post(props: IClienteForm): Promise<AxiosResponse<IClienteDTO>> {
    return ApiBrave.post(`${basePath}`, props);
  }

  static async get(
    props?: IClienteGetProps
  ): Promise<AxiosResponse<IPageClienteDTO>> {
    let params = "";
    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }
    return ApiBrave.get(params ? `${basePath}?${params}` : basePath);
  }

  static async getById({
    id,
  }: {
    id: string;
  }): Promise<AxiosResponse<IClienteDTO>> {
    return ApiBrave.get(`${basePath}/buscar/${id}`);
  }

  static async getConcessionarias(
    props?: IConcessionariaProps
  ): Promise<AxiosResponse<IPageClienteDTO>> {
    const values = removeEmpty(props);
    const params = objectToParams(values);
    return ApiBrave.get(
      params
        ? `${basePath}/listar-concessionarias?${params}`
        : `${basePath}/listar-concessionarias`
    );
  }

  static async lista(
    props: IClienteList
  ): Promise<AxiosResponse<IPageClienteDTO>> {
    const params = objectToParams(props);
    return ApiBrave.get(`${basePath}/listar?${params}`);
  }

  static async getByUsuario({
    uuidUsuario,
  }: {
    uuidUsuario: string;
  }): Promise<AxiosResponse<IClienteDTO>> {
    return ApiBrave.get(`${basePath}/usuario/${uuidUsuario}`);
  }

  static async atualizar(
    props: IClienteAtualizarForm
  ): Promise<AxiosResponse<IClienteDTO>> {
    const { uuid, ...data } = props;
    return ApiBrave.put(`${basePath}/${uuid}/atualizar`, data);
  }

  static async byId({
    uuidCliente,
  }: {
    uuidCliente: string;
  }): Promise<AxiosResponse<IClienteDTO>> {
    return ApiBrave.get(`${basePath}/buscar/${uuidCliente}`);
  }

  static async resetPassword({
    uuidCliente,
  }: {
    uuidCliente: string;
  }): Promise<AxiosResponse<string>> {
    return ApiBrave.put(`${basePath}/${uuidCliente}/resetar-senha`);
  }
}
